export const SESSION_STORAGE = {
  DEVICE_ID: 'device-id',
  FULL_QUERY: 'full_query',
  HIDE_HEADER: 'hideHeader',
  IS_SDK: 'isSDK',
  OFFER_CONFIG_UUIDS: 'offerConfigUUIDs',
  PLATFORM: 'platform',
  PREAPPROVAL_CODE: 'preapproval_code',
  PRM: 'prm',
  PHONE: 'phone',
  SESSION_ID: 'imprint_web_app_session_id',
  SSA_DISCLOSURE_ACCEPTED: 'imprint_ssa_disclosure_accepted',
  STORE_NUMBER: 'store_number',
  EMPLOYEE_ID: 'employee_id',
  UTM_CAMPAIGN: 'utm_campaign',
  UTM_CONTENT: 'utm_content',
  UTM_MEDIUM: 'utm_medium',
  UTM_SOURCE: 'utm_source',
  UTM_TERM: 'utm_term',
} as const;
